import api from 'apiConfig/axiosConfig';
import * as actionTypes from './capacityActionTypes';
import { 
    CapacityModel
} from './capacityStateModel';


//Default
export const fetchingCapacity = (status: boolean) => {
    return {
        type: actionTypes.FETCHING_CAPACITY,
        payload: status
    }
}


//Success
export const getCapacitySuccess = (capacity: CapacityModel) => {
    return {
        type: actionTypes.GET_CAPACITY_SUCCESS,
        payload: capacity
    }
}


//Failure
export const getCapacityFailure = (capacityErrorMessage: string) => {
    return {
        type: actionTypes.GET_CAPACITY_FAILURE,
        payload: capacityErrorMessage
    }
}

//Triggers
export const getCapacityAsync = (
    companyName: string,
    contactName: string,
    mpan: string, 
    mpanTopline: string, 
    importCapacity: number, 
    preCovid: boolean,
    loa?: File, 
    phoneNumber?: string
) => {
    return dispatch => {
        dispatch(fetchingCapacity(true));
        dispatch(getCapacityFailure(""));

        const formData = new FormData();
        formData.append('loa', loa);

        const postType = () => {
            if (loa) {
                return api.post('/tcr/duos', formData, {
                    params: {
                        mpan, mpanTopline, importCapacity, preCovid, companyName, contactName
                    },
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                })
            }

            return api.post('/tcr/duos', {
                companyName,
                contactName,
                mpan, 
                mpanTopline, 
                importCapacity, 
                preCovid,
                phoneNumber
            })
        };

        postType()
        .then(response => {
            const res: CapacityModel = response.data;

            dispatch(getCapacitySuccess(res));
            dispatch(fetchingCapacity(false));
            dispatch(getCapacityFailure(""));
        })
        .catch(error => {
            dispatch(fetchingCapacity(false));
            const errorCode: string = error.response.data.code;

            switch (errorCode) {
                case 'INVALID_MPAN':
                    return dispatch(getCapacityFailure('The MPAN you entered in invalid. Please check your details and try again.'));
                case 'NON_HALF_HOURLY_METER':
                    return dispatch(getCapacityFailure('Non half-hourly meters are not supported at this time.'));
                case 'LLFC_NOT_FOUND':
                    return dispatch(getCapacityFailure('No LLFC could be found for this meter. Please contact your system adminstrator.'));
                case 'G_CLASS_METER':
                    return dispatch(getCapacityFailure('Non-CT meters are not supported at this time.'));
                case 'HISTORIC_TARIFF_NOT_FOUND':
                    return dispatch(getCapacityFailure('No historic tariffs could be found for this meter. Please check your details and try again, or contact your system administrator.'));
                case 'FUTURE_TARIFF_NOT_FOUND':
                    return dispatch(getCapacityFailure('No future tariffs could be found for this meter. Please check your details and try again, or contact your system administrator.'));
                default:
                    return dispatch(getCapacityFailure('An unknown error occurred. Please contact your system administrator.'));
            }
        })
    }
}

export const getPublicCapacityAsync = (
    mpan: string,
    mpanTopline: string, 
    importCapacity: number, 
    phoneNumber: string,
    companyName: string,
    contactName: string,
    contactEmail: string,
    preCovid: boolean
    
) => {
    return dispatch => {
        dispatch(fetchingCapacity(true));
        dispatch(getCapacityFailure(""));

        api.get(`/public/tcr/duos`, {
            params: {
                mpan,
                mpanTopline,
                importCapacity,
                phoneNumber,
                companyName,
                contactName,
                contactEmail,
                preCovid
            }
        })
        .then(response => {
            const res: CapacityModel = response.data;

            dispatch(getCapacitySuccess(res));
            dispatch(fetchingCapacity(false));
            dispatch(getCapacityFailure(""));
        })
        .catch(error => {
            dispatch(fetchingCapacity(false));
            const errorCode: string = error.response.data.code;

            switch (errorCode) {
                case 'INVALID_MPAN':
                    return dispatch(getCapacityFailure('The MPAN you entered in invalid. Please check your details and try again.'));
                case 'NON_HALF_HOURLY_METER':
                    return dispatch(getCapacityFailure('Non half-hourly meters are not supported at this time.'));
                case 'LLFC_NOT_FOUND':
                    return dispatch(getCapacityFailure('No LLFC could be found for this meter. Please contact your system adminstrator.'));
                case 'G_CLASS_METER':
                    return dispatch(getCapacityFailure('Non-CT meters are not supported at this time.'));
                case 'HISTORIC_TARIFF_NOT_FOUND':
                    return dispatch(getCapacityFailure('No historic tariffs could be found for this meter. Please check your details and try again, or contact your system administrator.'));
                case 'FUTURE_TARIFF_NOT_FOUND':
                    return dispatch(getCapacityFailure('No future tariffs could be found for this meter. Please check your details and try again, or contact your system administrator.'));
                default:
                    return dispatch(getCapacityFailure('An unknown error occurred. Please contact your system administrator.'));
            }
        })
    }
}


//Bundle and export all capacity actions
export const capacityActionTriggers = {
    getCapacityAsync: (
        companyName: string,
        contactName: string,
        mpan: string, 
        mpanTopline: string, 
        importCapacity: number, 
        preCovid: boolean, 
        loa: File, 
        phoneNumber: string
    ) => getCapacityAsync(companyName, contactName, mpan, mpanTopline, importCapacity, preCovid, loa, phoneNumber),
    getPublicCapacityAsync: (
        mpan: string,
        mpanTopline: string, 
        importCapacity: number, 
        phoneNumber: string,
        companyName: string,
        contactName: string,
        contactEmail: string,
        preCovid: boolean
    ) => getPublicCapacityAsync(mpan, mpanTopline, importCapacity, phoneNumber, companyName, contactName, contactEmail, preCovid),
    getCapacityFailure: (capacityErrorMessage: string) => getCapacityFailure(capacityErrorMessage),
    getCapacitySuccess: (capacity: CapacityModel) => getCapacitySuccess(capacity)
};